import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Severities, formatAlarmValue, speed } from "../../constant";
import { formatDate } from "@telerik/kendo-intl";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { ToastContainer } from "react-toastify";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import "rc-slider/assets/index.css";
import Slider from "rc-slider";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";

const PlayBackTrack = forwardRef(
  (
    {
      dateRange,
      playBackData,
      setMomentData,
      currentPlayTime,
      setCurrentPlayTime,
      assetData,
      getTimeZoneDateTime,
      setLoading,
      pointDatas,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [fastForward, setFastForward] = useState(speed[0]);
    const [intervalId, setIntervalId] = useState(null);
    const [sliderValue, setSliderValue] = useState(0);
    const [jumbTimePopup, setJumbTimePopup] = useState(false);
    const [jumbTime, setJumbTime] = useState(null);
    const [playIndex, setPlayIndex] = useState(0);
    const [buttonEnabled, setButtonEnabled] = useState({
      play: false,
      fastForward: false,
      stopOnAlarm: false,
    });
    // const [pointDatas, setPointDatas] = useState([]);
    const [marks, setMarks] = useState({});

    useImperativeHandle(ref, () => ({
      clearChildState() {
        setSliderValue(0);
        setButtonEnabled((pre) => ({ ...pre, play: false }));
        clearInterval(intervalId);
        setFastForward(speed[0]);
      },
    }));

    const toggleSpeed = () => {
      setFastForward((pre) => {
        const currentIndex = speed.indexOf(pre);
        const nextIndex = (currentIndex + 1) % speed.length;
        setFastForward(speed[nextIndex]);
        onPauseClick(intervalId);
        return speed[nextIndex];
      });
    };

    // const getModifiedData = (newData) => {
    //   const isLatValid =
    //     newData.gnss.latitude !== 0 && !newData.gnss.latitude.startsWith("0");
    //   const modifiedData = {
    //     ...newData,
    //     gnss: isLatValid
    //       ? {
    //           Latitude: newData.gnss.latitude,
    //           Longitude: newData.gnss.longitude,
    //         }
    //       : {
    //           Latitude: 0,
    //           Longitude: 0,
    //         },
    //     Values: newData.values.map((v) => ({
    //       Id: v.id,
    //       ParameterId: v.parameterId,
    //       Value: v.value,
    //       AssetId: v.assetId,
    //     })),
    //   };
    //   return modifiedData;
    // };

    const getDevicedTime = () => {
      const timeDifferenceMs =
        dateRange.endDate.getTime() -
        dateRange.startDate.getTime();
      const minutesDifference = Math.floor(timeDifferenceMs / (1000 * 60));
      const divisedTime = 100 / minutesDifference;
      return divisedTime;
    };

    const onPlayClicked = (delay) => {
      setButtonEnabled((prevButtonState) => ({
        ...prevButtonState,
        play: true,
      }));
      let mainDelay = 1000 / delay;
      const id = setInterval(() => {
        setPlayIndex((pre) => {
          if (pre < pointDatas.length) {
            const data = pointDatas[pre];
            let recalculatedDelay = mainDelay / data.dataAndAlarm.length;

            data.dataAndAlarm.forEach((el, index) => {
              setTimeout(() => {
                setMomentData({
                  data: el.data,
                  dragging: false,
                  alarms: el.alarms,
                });
              }, index * recalculatedDelay);
            });
            setSliderValue(data.sliderPoint);
            setCurrentPlayTime(data.timeStamp);
            return pre + 1;
          } else {
            clearInterval(id);
            setButtonEnabled((prev) => ({ ...prev, play: false }));
            return pre;
          }
        });
      }, mainDelay);
      setIntervalId(id);
    };

    const SetPointDatas = debounce(async (addedTime) => {
      setLoading(true);
      let newData = pointDatas.find((x) => x.timeStamp === addedTime);
      let index = pointDatas.findIndex((x) => x.timeStamp === addedTime);
      if (!newData) {
        let minTimeDiff = null;
        pointDatas.forEach((el, i) => {
          if (el.timeStamp < addedTime) {
            if (minTimeDiff === null) {
              minTimeDiff = addedTime - el.timeStamp;
            } else {
              const timeDiff = addedTime - el.timeStamp;
              if (timeDiff < minTimeDiff) {
                minTimeDiff = timeDiff;
                newData = el;
                index = i;
              }
            }
          }
        });
      }
      let modifiedData = null;

      if (newData) {
        modifiedData = newData.dataAndAlarm[0].data;
      }

      const rangePointDatas = pointDatas
        .filter(
          (x) =>
            (!newData || x.timeStamp < newData.timeStamp) &&
            (newData || x.timeStamp < addedTime)
        )
        .map((x) => x.dataAndAlarm)
        .flat();
      const rangeDatas = rangePointDatas.map((x) => x.data).filter((x) => x);
      const newAlarms = rangePointDatas
        .map((x) => x.alarms)
        .flat()
        .filter((x) => x !== null);
      const sortedAlarms = newAlarms.sort((a, b) => b.timeStamp - a.actionTime);
      if (index !== -1) {
        setPlayIndex(index);
        setMomentData({
          data: modifiedData,
          dragging: true,
          rangeAlarms: sortedAlarms,
          rangeDatas,
          alarms: newAlarms.length > 0 ? newAlarms : null,
        });
      } else {
        setPlayIndex(0);
        setMomentData({
          data: modifiedData,
          dragging: true,
          rangeAlarms: [],
          rangeDatas: [],
          alarms: [],
        });
      }

      setLoading(false);
    }, 1000);

    const onSliderChange = (value, complete) => {
      setIntervalId((pre) => onPauseClick(pre));
      setSliderValue(value);
      const divisedTime = getDevicedTime();
      const devisedValue = value / divisedTime;
      let addedTime = new Date(
        dateRange.startDate.getTime() +
        parseInt(devisedValue) * 60000
      );
      setCurrentPlayTime(addedTime);
      if (complete) {
        SetPointDatas(addedTime);
      }
    };

    const onPauseClick = (interval) => {
      setButtonEnabled((pre) => ({ ...pre, play: false }));
      clearInterval(interval);
    };

    const onApplyJumbTime = async () => {
      setIntervalId((pre) => onPauseClick(pre));
      setLoading(true);
      const modifiedJumbTime = jumbTime;
      setCurrentPlayTime(modifiedJumbTime);
      let newData = pointDatas.find((x) => x.timeStamp === modifiedJumbTime);
      let index = pointDatas.findIndex((x) => x.timeStamp === modifiedJumbTime);
      if (!newData) {
        let minTimeDiff = null;
        pointDatas.forEach((el, i) => {
          if (el.timeStamp < modifiedJumbTime) {
            if (minTimeDiff === null) {
              minTimeDiff = modifiedJumbTime - el.timeStamp;
            } else {
              const timeDiff = modifiedJumbTime - el.timeStamp;
              if (timeDiff < minTimeDiff) {
                minTimeDiff = timeDiff;
                newData = el;
                index = i;
              }
            }
          }
        });
      }
      // If foundDataIndex is -1, the element is not found. Otherwise, it contains the index.
      if (newData !== null) {
        const position = newData.sliderPoint;
        // 1 +
        // ((modifiedJumbTime) -
        //   dateRange.startDate)) /
        //   (dateRange.endDate) -
        //     dateRange.startDate))) *
        //   99;
        setPlayIndex(index);
        setSliderValue(position);

        const rangeDataAlarms = pointDatas
          .filter((x) => x.timeStamp < newData.timeStamp)
          .map((x) => x.dataAndAlarm)
          .flat();
        const rangeData = rangeDataAlarms.map((x) => x.data).filter((x) => x);
        // const newAlarms = playBackData.alarms.filter(
        //   (x) => x.timeStamp <= newData.timeStamp
        // );
        const sortedAlarms = rangeDataAlarms
          .map((x) => x.alarms)
          .sort((a, b) => b.timeStamp - a.actionTime);
        const modifiedData = rangeData.sort(
          (a, b) => a.timeStamp - b.timeStamp
        )[rangeData.length - 1];

        setMomentData({
          data: modifiedData,
          dragging: true,
          rangeAlarms: sortedAlarms,
          rangeDatas: rangeData,
          alarms: null,
        });
      }
      setJumbTimePopup(false);
      setLoading(false);
    };

    useEffect(() => {
      let alarmData = null;

      if (playBackData.datas.length > 0) {
        playBackData.datas.forEach((el) => {
          const position =
            ((el.timeStamp.getTime() - dateRange.startDate.getTime()) /
              (dateRange.endDate.getTime() - dateRange.startDate.getTime())) *
            100;
          alarmData = {
            ...alarmData,
            [position]: (
              <div
                className={`tooltip h-2 w-[0.5px] mt-0 bg-white flex justify-center items-center`}
              ></div>
            ),
          };
        });
      }
      if (playBackData.alarms.length > 0) {
        playBackData.alarms.forEach((el) => {
          const param = assetData?.parameters.find(
            (s) => s.parameterId === el.parameterId
          );
          const severity = Severities.find((x) => x.value === el.status);
          const position =
            ((el.timeStamp.getTime() - dateRange.startDate.getTime()) /
              (dateRange.endDate.getTime() - dateRange.startDate.getTime())) *
            100;
          alarmData = {
            ...alarmData,
            [position]: (
              <div
                className={`tooltip h-2 w-[0.5px] mt-0 bg-${severity.bgColor} flex justify-center items-center`}
              >
                <div className="tooltiptext flex flex-col gap-1 items-center w-fit z-100 truncate font-semibold text-xxs bg-red-500">
                  <span>{param?.name}</span>
                  <div className="flex gap-1">
                    <img
                      src={severity.icon}
                      alt="Severity_Icon"
                      className={`${severity.color} rounded-full w-4 h-4 p-1 border`}
                    />
                    <span className="pr-1">
                      {formatAlarmValue(
                        el.alarmType,
                        el.sensorValue,
                        "flex-row"
                      )}
                      {param?.unit}
                    </span>
                  </div>
                </div>
              </div>
            ),
          };
        });
      }
      if (alarmData !== null) setMarks(alarmData);
    }, []);

    return (
      <div className="fixed bottom-2 left-0 flex items-center w-full gap-3 bg-gray-900 bg-opacity-50 p-2">
        {!buttonEnabled.play ? (
          <button
            type="button"
            className={`bg-blue-600 rounded-full h-8 w-8 flex flex-shrink-0 justify-center items-center`}
            onClick={() =>
              setFastForward((pre) => {
                onPlayClicked(pre);
                return pre;
              })
            }
          >
            <img src="play-button.svg" alt="play" />
          </button>
        ) : (
          <button
            type="button"
            className={`bg-blue-600 rounded-full h-8 w-8 flex flex-shrink-0 justify-center items-center`}
            onClick={() => onPauseClick(intervalId)}
          >
            <img src="pause-button.svg" alt="pause" />
          </button>
        )}
        <button
          type="button"
          className={`${buttonEnabled.fastForward ? "bg-blue-600" : "bg-gray-400"
            } rounded-full h-8 w-8 flex justify-center flex-shrink-0 items-center`}
          onClick={() => toggleSpeed()}
        >
          {
            <span className="text-white font-medium text-xs">
              {fastForward}x
            </span>
          }
        </button>
        <button
          type="button"
          className={`${buttonEnabled.stopOnAlarm ? "bg-blue-600" : "bg-gray-400"
            } rounded-full h-8 w-8 p-2 flex justify-center flex-shrink-0 items-center`}
          onClick={() =>
            setButtonEnabled((pre) => ({
              ...pre,
              stopOnAlarm: !pre.stopOnAlarm,
            }))
          }
        >
          <div className="tooltip">
            <img
              src={
                buttonEnabled.stopOnAlarm ? "bellEnable.svg" : "bellDisable.svg"
              }
              alt="bell"
              className="h-5"
            />
            <span className="tooltiptext flex flex-col truncate w-fit leading-4 space-y-0 text-xxs">
              {buttonEnabled.stopOnAlarm
                ? "Stop on Alarms"
                : "Not Stop on Alarms"}
            </span>
          </div>
        </button>
        <div className="relative">
          {jumbTimePopup && (
            <div className="bg-black rounded-md p-2 flex flex-col justify-center gap-2 absolute -top-24 -left-10">
              <DateTimePicker
                width={200}
                placeholder="Select Jumb Time"
                format="dd-MM-yyyy hh:mm a"
                max={dateRange.endDate}
                min={dateRange.startDate}
                value={jumbTime}
                onChange={(e) => setJumbTime(e.value)}
              />
              <div className="flex justify-end items-center gap-2 text-xs text-white font-medium">
                <button
                  type="button"
                  className="bg-indigo-600 z-40 md:px-2 px-1 md:h-7 w-full h-5 my-auto rounded disabled:opacity-40"
                  disabled={!jumbTime}
                  onClick={() => onApplyJumbTime()}
                >
                  {t("button.apply")}
                </button>
              </div>
            </div>
          )}
          {jumbTimePopup && (
            <div className="w-7 absolute -top-10 aspect-square rotate-45 bg-black"></div>
          )}
          <button
            type="button"
            onClick={() => {
              setJumbTimePopup(!jumbTimePopup);
            }}
            className={`bg-gray-400 rounded-full h-8 w-8 flex justify-center flex-shrink-0 items-center`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="white"
              class="w-5 h-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
        </div>
        <div className="flex items-center w-full">
          <span className="ml-2 text-xxs text-white text-right mr-2 w-32">
            {dateRange.startDate
              ? formatDate(
                dateRange.startDate,
                "dd-MMM-yyyy hh:mm a"
              )
              : "Start Date"}
          </span>

          <div className="w-full z-10 relative h-5 flex items-center">
            {/* <RangeSlider
              value={{
                start: 0,
                end: sliderValue,
              }}
              onChange={(e) => onSliderChange(e)}
              style={{ width: "100%" }}
              step={1}
              min={0}
              max={100}
            /> */}
            <Slider
              dots
              min={0}
              marks={marks}
              startPoint={0}
              value={sliderValue}
              step={0.1}
              activeDotStyle={{
                borderColor: "rgb(37,99,235)",
                backgroundColor: "rgb(37,99,235)",
              }}
              dotStyle={{ borderColor: "#708090", backgroundColor: "#708090" }}
              keyboard
              onChange={(v) => onSliderChange(v, true)}
              onChangeComplete={(v) => onSliderChange(v, true)}
            />
            <div
              className={`absolute text-white -top-3 text-xxs z-10`}
              style={{ left: `${sliderValue}%` }}
            >
              {currentPlayTime &&
                formatDate(
                  new Date(currentPlayTime),
                  "dd-MMM-yyyy hh:mm a"
                )}
            </div>
          </div>
          <span className="ml-2 text-white text-xxs w-32">
            {dateRange.endDate
              ? formatDate(
                dateRange.endDate,
                "dd-MMM-yyyy hh:mm a"
              )
              : "End Date"}
          </span>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ToastContainer />
      </div>
    );
  }
);

export default PlayBackTrack;
